module.exports = __webpack_public_path__ + "img/bj42.e466bb47.png";